export default {
    login: "/security/login/",
    logout: "/security/logout/",
    login2fa: '/security/validate_login/',
    signup: "/security/welcome/",
    home: "/base/",
    walletAddresses: "/wallet/fetch_wallet_addresses/",
    requestEmail: "/security/request_email/",
    history: "/wallet/history/",
    firstPaint: "/base/first_paint/",
    countries: "/base/fetch_countries/",
    paymentMethods: "/b2c/fetch_payment_methods/",
    ussdSettings: "/ussd/settings/",
    passwordResetInternal: "/security/internal_password_reset/",
    deleteAccount: "/security/delete_account/",
    addressChange: "/base/address_change/",
    nameChange: "/base/name_change/",
    settings: "/base/basic_settings/",
    checkEnablers: "/base/checkers/",
    notifications: "/base/fetch_notifications/",
    openNotifications: "/base/open_notification/",
    checkNotifications: "/base/notifications/",
    addPaymentMethod: "/b2c/payment_methods/",
    phoneChange: "/base/phone_change/",
    coinData: "/wallet/coin_data/",
    tradePreview: "/b2c/preview/",
    initiateTrade: "/b2c/trade/",
    components: "/b2c/fetch_components/",
    placetTrade: "/b2c/trade/",
    walletData: "/wallet/fetch_wallet_data/",
    referralData: "/base/referral/",
    tfa: "/security/tfa/",
    checkEstimate: "/wallet/check_estimate/",
    validateEstimate: "/wallet/validate_estimate/",
    passwordResetExternal: "security/external_password_reset/",
    cancel_trade: '/base/cancel_trade/',
    offers: '/p2p/ads/',
    trade: '/p2p/trade/',
    fetchP2pComponents: '/p2p/fetch_components/',
    p2pPreview: 'p2p/preview/',
    tradeInfo: 'p2p/trader_info/',
    imageUpload: 'base/upload_image/',
    myoffers: '/p2p/offers/',
    transfer: '/p2p/transfer/',
    charts: '/base/coin_charts/',
    rewards: '/base/account_rewards/',
    tradeHistory: '/p2p/trade/history/',
    b2cHistory: '/b2c/history/',
    userEmailChange: "/base/email_change/",
    phone_change: "/base/phone_change/",
    completeSurvey: "base/complete_survey/",
    fetchLanguages: "base/fetch_languages/",
    getBalances: "wallet/get_balance/",
    qrPromo: "/base/qr_promo/"
}